class AnnouncementBarScroll extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.announcement-bar-scroll__wrapper');
    this.content = this.querySelector('.announcement-bar-scroll__content');
    
    if (!this.wrapper || !this.content) return;

    // Save the original items to use for duplication
    this.originalItems = Array.from(this.content.querySelectorAll('.announcement-bar-scroll__item'));
  }

  connectedCallback() {
    // Small timeout to ensure fonts are loaded and widths are correct
    setTimeout(() => {
      this.init();
    }, 100);
    window.addEventListener('resize', this.debounce(this.init.bind(this), 250));
  }

  init() {
    if (!this.content || this.originalItems.length === 0) return;

    // Reset content to original elements only
    this.content.innerHTML = '';
    this.originalItems.forEach(item => {
      // Must deeply clone again from memory otherwise we move it out
      this.content.appendChild(item.cloneNode(true));
    });

    // Remove any previously cloned content wrapper
    const clones = this.wrapper.querySelectorAll('.announcement-bar-scroll__content[data-clone="true"]');
    clones.forEach(clone => clone.remove());

    // Fill until content block covers 2x screen width for smooth seamless looping.
    // The wrapper animates by -50% (= 1 content block), so each block must be wide
    // enough to cover the full viewport with buffer for sub-pixel transitions.
    const screenWidth = window.innerWidth;
    let contentWidth = this.content.offsetWidth;
    let loopCount = 0;

    while (contentWidth < screenWidth * 2 && loopCount < 50) {
      this.originalItems.forEach(item => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        this.content.appendChild(clone);
      });
      contentWidth = this.content.offsetWidth;
      loopCount++;
    }

    // Clone the entire first block to create the seamless infinite scrolling queue
    const contentClone = this.content.cloneNode(true);
    contentClone.setAttribute('data-clone', 'true');
    contentClone.setAttribute('aria-hidden', 'true');
    this.wrapper.appendChild(contentClone);

    // Apply calculated speed based on content width to ensure constant velocity
    const baseSpeed = parseFloat(this.getAttribute('data-speed')) || 15;
    // Calculate final duration: baseSpeed is the time taken to travel 1000px
    const actualDuration = (this.content.offsetWidth / 1000) * baseSpeed;
    this.style.setProperty('--scroll-speed', `${actualDuration}s`);
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('announcement-bar-scroll', AnnouncementBarScroll);
